@if (isLoading || isLoadingTotals) {
  <div class="loading-indicator">
    <mat-progress-spinner
      mode="indeterminate"
      color="accent"
    ></mat-progress-spinner>
  </div>
}
@if (!isLoading && !isLoadingTotals && totalSalesMails > 0 && openHoursWithMaxValue.length < 6) {
  <div class="mm_container">
    <div class="mm_row mm_bottom_border">
      <div class="mm_row_icon">
        <fa-icon [icon]="['fas', 'envelope-open']"></fa-icon>
        <span class="mm_row_icon_subheader">OPENS</span>
      </div>
      <div class="mm_row_text">
        <fa-icon icon="caret-right" class="arrow fade_arrow"></fa-icon>
        <fa-icon icon="caret-right" class="arrow mr_arrow"></fa-icon>
        {{ mostOpenedTime }} {{ mostOpenedDay }}
        <fa-icon icon="caret-left" class="arrow ml_arrow"></fa-icon>
        <fa-icon icon="caret-left" class="arrow fade_arrow"></fa-icon>
      </div>
    </div>
    <div class="mm_row">
      <div class="mm_row_icon">
        <fa-icon [icon]="['fas', 'eye']"></fa-icon>
        <span class="mm_row_icon_subheader">VIEWS</span>
      </div>
      <div class="mm_row_text">
        <fa-icon icon="caret-right" class="arrow fade_arrow"></fa-icon>
        <fa-icon icon="caret-right" class="arrow mr_arrow"></fa-icon>
        {{ mostViewedTime }} {{ mostViewedDay }}
        <fa-icon icon="caret-left" class="arrow ml_arrow"></fa-icon>
        <fa-icon icon="caret-left" class="arrow fade_arrow"></fa-icon>
      </div>
    </div>
  </div>
}
@if ((!isLoading && !isLoadingTotals && totalSalesMails == 0 && !error) || openHoursWithMaxValue.length > 5) {
  <div>
    <p>
      Money Making Hours will be available after more data has been collected.
    </p>
  </div>
}
@if (error) {
  <p class="chartErrorText">{{ error }}</p>
}
